import { Sheet } from '@sravni/react-design-system/lib/Sheet';
import { Sidepage } from '@sravni/react-design-system/lib/Sidepage';
import { useIsMobile } from '@sravni/react-utils';
import { useMemo } from 'react';

export const useCrossSidepage = () => {
  const isMobile = useIsMobile();

  return useMemo(() => (isMobile ? Sheet : Sidepage), [isMobile]);
};
